"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Copyright (c) 2021 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */
var routes = {
  Error: '/error',
  Login: '/login',
  RegisterNewAccount: '/register-new-account',
  RequestPasswordReset: '/reset-password',
  ResetPassword: '/update-password',
  ThirdPartyLicenses: '/third-party-licenses',
  UserPreferences: '/preferences'
};
var _default = routes;
exports["default"] = _default;